import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { lenisStore, scrollToHash, scrollTop } from "@/utils/scroll";
import Home from "@/pages/Home";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Avis from "@/pages/Avis";
import RendezVous from "@/pages/RendezVous";
import Legal from "@/pages/Legal";
import EtudeDeCas from "@/pages/EtudeDeCas";
import Formation from "@/pages/Formation";

const LenisSetup = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisStore.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisStore.current = null;
    };
  }, []);
  return null;
};

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const timer = setTimeout(() => scrollToHash(location.state.scrollTo), 300);
      return () => clearTimeout(timer);
    }
    scrollTop();
  }, [location.key]);
  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisSetup />
        <ScrollManager />
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/etude-de-cas/:slug" element={<EtudeDeCas />} />
          <Route path="/formation" element={<Formation />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/avis" element={<Avis />} />
          <Route path="/rendez-vous" element={<RendezVous />} />
          <Route path="/mentions-legales" element={<Legal slug="mentions-legales" />} />
          <Route path="/politique-de-confidentialite" element={<Legal slug="politique-de-confidentialite" />} />
          <Route path="/cgv" element={<Legal slug="cgv" />} />
          <Route path="/politique-de-cookies" element={<Legal slug="politique-de-cookies" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
